module.exports = __webpack_public_path__ + "img/1970East-071_WEB-min.efc04557.jpg";